import axios from "../../axios";

const header = (token) => ({
  headers: {
    Authorization: "Bearer " + token
  }
});

const baseUrl = () => process.env.VUE_APP_API_BASE_URL + '/api';

export default {
  pending(token, params = {}) {
    axios.defaults.baseURL = `${baseUrl()}/approval/pending`;
    return axios.get('', { params, ...header(token) });
  },

  myRequests(token, params = {}) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests`;
    return axios.get('', { params, ...header(token) });
  },

  find(token, id) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/${id}`;
    return axios.get('', header(token));
  },

  openSchedule(token, tenantId) {
    axios.defaults.baseURL = `${baseUrl()}/approval/tenants/${tenantId}/open-schedule`;
    return axios.get('', header(token));
  },

  tenantHistory(token, tenantId, params = {}) {
    axios.defaults.baseURL = `${baseUrl()}/approval/tenants/${tenantId}/history`;
    return axios.get('', { params, ...header(token) });
  },

  exportTenantHistory(token, tenantId) {
    axios.defaults.baseURL = `${baseUrl()}/approval/tenants/${tenantId}/history/export`;
    return axios.get('', { responseType: 'blob', ...header(token) });
  },

  create(token, payload) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests`;
    return axios.post('', payload, header(token));
  },

  previewBulk(token, payload) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/bulk-preview`;
    return axios.post('', payload, header(token));
  },

  createBulk(token, payload) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/bulk`;
    return axios.post('', payload, header(token));
  },

  update(token, id, payload) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/${id}`;
    return axios.put('', payload, header(token));
  },

  cancel(token, id, comment = null) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/${id}`;
    return axios.delete('', {
      data: { comment },
      ...header(token)
    });
  },

  decide(token, id, data) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/${id}/decision`;
    return axios.post('', data, header(token));
  },

  execute(token, id, data) {
    axios.defaults.baseURL = `${baseUrl()}/approval/requests/${id}/execute`;
    return axios.post('', data, header(token));
  }
}
